import './Text.css';

export function BookmarksForBrooklynPark() {
  return (
<div class="body">

<div class="row" id="GalleryTwo">
  <div class="column" >   
           <h2>
            Bookmarks For Brooklyn Park, 2026</h2>
                Minneapolis ICE Surge Fundraiser
                <br/><br/>
                Oil-Based Ink, 
Woodcut Relief prints on paper.
Screen Print on paper.

                </div>
                                  <div class="column">

</div>
                  <div class="column">
        <img  src="Bookmark1.png"></img>
</div>

<div class="column">
        <img  src="Bookmark2.png"></img>  
</div>
                <div class="column">
        <img  src="Bookmark6.jpg"></img>
</div>
</div>

<div class="row" id="GalleryThree">
  <div class="column">
        <img  src="Bookmark1.png"></img>
</div>

<div class="column">
        <img  src="Bookmark2.png"></img>  
</div>

<div class="column">     
<h2>On Tyranny</h2>
<br/>
<a target="0" href="https://ia801505.us.archive.org/11/items/on-tyranny-twenty-lessons-from-the-twentieth-century-by-timothy-snyder-z-lib.org/On%20Tyranny%20Twenty%20Lessons%20from%20the%20Twentieth%20Century%20by%20Timothy%20Snyder%20%28z-lib.org%29.pdf">
Twenty Lessons from the Twentieth Century  
</a>
<br/>
Timothy Synder, 2017
<br/><br/><br/>
1. Do not obey in advance.
<br/><br/>2. Defend institutions.
<br/><br/>3. Beware the one-party state.
<br/><br/>4. Take responsibility for the face of the world.
<br/><br/>5. Remember professional ethics.
<br/><br/>6. Be wary of paramilitaries.
<br/><br/>7. Be reflective if you must be armed.
<br/><br/>8. Stand out.
<br/><br/>9. Be kind to our language.
<br/><br/>10. Believe in truth.
<br/><br/>11. Investigate.
<br/><br/>12. Make eye contact and small talk.
<br/><br/>13. Practice corporeal politics.
<br/><br/>14. Establish a private life.
<br/><br/>15. Contribute to good causes.
<br/><br/>16. Learn from peers in other countries.
<br/><br/>17. Listen for dangerous words
<br/><br/>18. Be calm when the unthinkable arrives.
<br/><br/>19. Be a patriot.
<br/><br/>20. Be as courageous as you can.
<br/>

</div></div>

<div class="row" id="GalleryTwo">
<div class="column">
  <img  src="Bookmark3.jpg"></img>
  </div>
<div class="column">
        <img  src="Bookmark4.jpg"></img>
</div>
<div class="column">
        <img  src="Bookmark5.jpg"></img>
</div>
</div></div>

  );
}
